import { SET_SELECTED_STUDENT } from "../actions/SelectStudentAction";

const initialState = {
  selectedStudent: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_STUDENT:
      return {
        ...state,
        selectedStudent: action.payload,
      };
    default:
      return state;
  }
};
